import { useRouter } from 'next/router'
import { VideoData } from '../../../interfaces'
import styled from 'styled-components'
import * as React from 'react'

const OuterDiv = styled.div`
  width: calc(100% - 30px);
  display: flex;
  flex-direction: column;
  padding: 15px;
  border-radius: 10px;
  cursor: pointer;

  :hover {
    background-color: #323232;
  }
`

const InnerDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`

const VideoThumbnailContainer = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  border-radius: 5px;
  cursor: pointer;

  @media (min-width: 62em) {
    border-radius: 5px;
  }
`

const VideoThumbnail = styled.div<{ poster: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  background-color: black;
  cursor: pointer;
  background-image: url(${(props) => props.poster});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  @media (min-width: 62em) {
    border-radius: 5px;
  }
`

const Title = styled.span<{ neutral: boolean; hasTitle?: boolean }>`
  color: ${(props) => (props.neutral ? 'white' : 'rgb(48, 209, 88)')};
  font-size: 14px;
  font-weight: 600;
  white-space: pre;
  max-width: ${(props) => (props.hasTitle ? '300px' : '')};
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 15px;

  @media (min-width: 43em) {
    font-size: 17px;
    max-width: ${(props) => (props.hasTitle ? '400px' : '')};
  }
`

const VideoHitItem = ({
  video,
  onClick,
}: {
  video: VideoData
  onClick: () => void
}): JSX.Element => {
  const router = useRouter()

  const handleOpenVideo = (video: string): void => {
    onClick()
    router.push(`/watch/${video}`)
  }

  return (
    <OuterDiv onClick={() => handleOpenVideo(video.address)}>
      <InnerDiv>
        <div style={{ width: '80px' }}>
          <VideoThumbnailContainer>
            <VideoThumbnail
              poster={`https://glassimg.imgix.net/${video.thumbnail_uri}?ar=16:9&fit=crop&fm=webp&w=400&h=225`}
            />
          </VideoThumbnailContainer>
        </div>
        <Title neutral hasTitle>
          {video.title}
        </Title>
      </InnerDiv>
    </OuterDiv>
  )
}

export default VideoHitItem
